export default __webpack_public_path__ + "static/media/aventurier.bb6f87e9.jpeg";